const pageAfterLogin = userRoles => {
  if (!userRoles) return false

  let rolePage = '/'
  if (userRoles.includes('press')) {
    rolePage = '/editorials'
  } else if (userRoles.includes('archive')) {
    rolePage = '/archive'
  }
  return userRoles.includes('god') || userRoles.includes('admin') ? '/' : rolePage
}

const canNavigateTo = (userRoles, to) => {
  if (!userRoles) return false

  let includeRole = false
  const endpoint = to.split('/')[1]

  if (endpoint === '') {
    includeRole = userRoles.includes('admin')
  } else if (endpoint === 'archive') {
    includeRole = userRoles.includes('archive')
  } else if (endpoint === 'editorials') {
    includeRole = userRoles.includes('press')
  } else if (endpoint === 'instagram') {
    includeRole = userRoles.includes('archive')
  } else if (endpoint === 'manual_input') {
    includeRole = userRoles.includes('archive') || userRoles.includes('press')
  } else if (endpoint === 'search') {
    includeRole = userRoles.includes('press') || userRoles.includes('archive')
  } else if (endpoint === 'advanced_search') {
    includeRole = userRoles.includes('press') || userRoles.includes('archive')
  } else if (endpoint === 'previews') {
    includeRole = true
  } else if (endpoint === 'resource_notifications') {
    includeRole = true
  }

  return includeRole || userRoles.includes('god')
}

const canSetSearchField = (userRoles, field) => {
  if (!userRoles) return false

  const pressFields = ['magazine_names', 'magazine_countries', 'collections']
  const archiveFields = [
    'magazine_names', 
    'magazine_countries', 
    'collections', 
    'dates', 
    'stylist', 
    'photographer'
  ]

  let canSetField = false
  if (userRoles.includes('press')) {
    canSetField = pressFields.includes(field)
  } else if (userRoles.includes('archive')) {
    canSetField = archiveFields.includes(field)
  }

  return canSetField || userRoles.includes('god') || userRoles.includes('admin') 
}

const canNavigateToAdmin = (userRoles) => {
  if (!userRoles) return false
    
  return userRoles.includes('god') || userRoles.includes('admin')
}

const canDraftResourceFromSearch = (userRoles) => {
  if (!userRoles) return false

  return userRoles.includes('god') || userRoles.includes('admin')
}

export { pageAfterLogin, canNavigateTo, canSetSearchField, canNavigateToAdmin, canDraftResourceFromSearch }
